var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1139.1 295.31c12.941 0 23.438-10.492 23.438-23.438v-210.94c0-12.945-10.496-23.438-23.438-23.438h-210.94c-12.941 0-23.438 10.492-23.438 23.438v70.312h-609.38v-70.312c0-12.945-10.492-23.438-23.438-23.438h-210.94c-12.945 0-23.438 10.492-23.438 23.438v210.94c0 12.945 10.492 23.438 23.438 23.438h70.312v609.38h-70.312c-12.945 0-23.438 10.496-23.438 23.438v210.94c0 12.941 10.492 23.438 23.438 23.438h210.94c12.945 0 23.438-10.496 23.438-23.438v-70.312h609.38v70.312c0 12.941 10.496 23.438 23.438 23.438h210.94c12.941 0 23.438-10.496 23.438-23.438v-210.94c0-12.941-10.496-23.438-23.438-23.438h-70.312v-609.38zm-187.5-210.94h164.06v164.06h-164.06v-164.06zm-867.19 0h164.06v164.06h-164.06zm164.06 1031.2h-164.06v-164.06h164.06v164.06zm867.19 0h-164.06v-164.06h164.06zm-93.75-210.94h-93.75c-12.941 0-23.438 10.496-23.438 23.438v93.75h-609.38v-93.75c0-12.941-10.492-23.438-23.438-23.438h-93.75v-609.38h93.75c12.945 0 23.438-10.492 23.438-23.438v-93.75h609.38v93.75c0 12.945 10.496 23.438 23.438 23.438h93.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectIcon);
export default __webpack_public_path__ + "static/media/rectIcon.3cc113d6badbb54add66edd7458303a1.svg";
export { ForwardRef as ReactComponent };